// @flow
import { sizes } from '../../assets/css/media';
export const isMobile = () => (
	typeof window.matchMedia !== 'undefined'
		? window.matchMedia(`(max-width: ${sizes.desktop - 1}px)`).matches
		: false
);

export default isMobile;


// WEBPACK FOOTER //
// ./src/utils/isMobile/index.js